import "./DataTable.scss";
import { useEffect, useState } from "react";
import { LoadTable } from "../../Components";
import Loading from "../../Components/Loading/Loading";

export default function DataTable({
  dragDiv,
  ledger,
  title,
  formdata,
  loading,
  error,
  length,
  crSum,
  drSum,
  roletable,
  selectedRows,
}) {
  const [FormData, setFormData] = useState(formdata ? formdata : []);
  useEffect(() => {
    if (formdata) {
      setFormData(formdata);
    }
  }, [formdata]);

  return (
    <div className="DataTable">
      {!formdata || loading ? (
        <h1>{error ? error.message : <Loading />}</h1>
      ) : (
        <>
          {/* {dragDiv} */}
          <LoadTable
            selectedRows={selectedRows}
            dragDiv={dragDiv}
            roletable={roletable}
            ledger={ledger}
            crSum={crSum}
            drSum={drSum}
            length={length}
            data={FormData}
            title={title}
            id="content"
          />
        </>
      )}
    </div>
  );
}
